var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"append":_vm.append,"prepend":_vm.prepend,"size":_vm.size}},[(!_vm.prepend && _vm.$slots.prepend)?[_vm._t("prepend")]:_vm._e(),_vm._t("default"),(!_vm.append && _vm.$slots.append)?[_vm._t("append")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }